import styled from '@emotion/styled';
import {
  ButtonNav,
  ButtonWrapper,
  ModalBottomSheet,
  TextParagraph,
  token,
} from '@ferreri/prever-component-lib';

type CardMembershipModalProps = {
  isOpen: boolean;
  onClose: () => void;
  handleSelectContract: (index: number) => void;
  contractsWithRoles: Array<{
    seq_control?: string;
    plan_group_name?: string;
    customer_code?: string;
  }>;
};

export const CardMembershipModal = (props: CardMembershipModalProps) => {
  return (
    <ModalBottomSheet
      isOpen={props.isOpen}
      onClose={props.onClose}
      title="Escolha o plano"
      hasCloseButton
      onBackdropClick={props.onClose}
      renderModalOnPortal={true}
    >
      <ModalContent>
        <TextParagraph>
          Escolha seu plano favorito para o qual deseja exibir a carteirinha:
        </TextParagraph>
        {props.contractsWithRoles?.map((contract, index) => (
          <ButtonWrapper
            key={contract?.seq_control}
            onClick={() => props.handleSelectContract(index)}
          >
            <ButtonNav
              label={contract?.plan_group_name}
              description={contract?.customer_code}
            />
          </ButtonWrapper>
        ))}
      </ModalContent>
    </ModalBottomSheet>
  );
};

const ModalContent = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxSmall};
  flex-direction: column;
`;
